import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "Feature Lede",
    description:
        "Lede module supports a variety of aspect ratios for media and media types.",
    links: [
        {
            name: "Figma",
            url: "https://www.figma.com/design/ecuKF9CTetHX35z2BJ8oa5/%F0%9F%90%A6%E2%80%8D%F0%9F%94%A5-Phoenix-Module-Repo?node-id=48-8989&m=dev",
        },
    ],
};
